import i18n from 'config/i18n/i18n';
import {campaignGraphqlRequest, productGraphqlRequest} from 'utils/graphqlRequests';

import {ECODE_ACTIVATION, GET_RM3_PROMOTION} from './queries';
import {PromoAdvice} from '../../types';
import {formatShopifyId} from '../../utils/product/getProPointPromotions';

export const redeemEcode = async (code: string) => {
  const result = await campaignGraphqlRequest(ECODE_ACTIVATION, {code});
  return result;
};

export const getComplexPromotion = async ({
  storeCodes,
  conditionFilter = 'ALL',
  version = 'v2',
  productIds,
  lang = i18n.language
}: {
  storeCodes: string[];
  conditionFilter?: string;
  version?: string;
  productIds: Array<{shopifyProductId: string; price: string}>;
  lang?: string;
}): Promise<PromoAdvice[]> => {
  const processedProductIds = productIds
    .filter((product) => !!product.shopifyProductId && product.shopifyProductId !== 'null')
    .map((product) => `${formatShopifyId(product.shopifyProductId)}|${product.price}`);

  try {
    const {getRM3Promotions: result} = await productGraphqlRequest(GET_RM3_PROMOTION, {
      ids: processedProductIds,
      storeCodes,
      version,
      conditionFilter,
      lang
    });

    let response: PromoAdvice[] = [];

    if (Array.isArray(result)) {
      response = result as unknown as PromoAdvice[];
    } else {
      console.error('Unexpected SDK response format:', result);
      return [];
    }

    return response;
  } catch (error) {
    console.error('Error in getComplexPromotion:', error);
    return [];
  }
};

export const getRmPromotions = async (
  productIds: Array<{shopifyProductId: string; price: string}>,
  storeCodes: string[]
): Promise<Record<string, {promoAdvice: PromoAdvice[]; loading: boolean}> | undefined> => {
  const promoMap: Record<string, {promoAdvice: PromoAdvice[]; loading: boolean}> = {};
  productIds.forEach((product) => {
    const identifier = product.shopifyProductId.replace('gid://shopify/Product/', '');
    promoMap[identifier] = {promoAdvice: [], loading: true};
  });

  try {
    const result = await getComplexPromotion({
      storeCodes,
      conditionFilter: 'ALL',
      productIds,
      lang: i18n.language
    });

    if (result && result.length > 0) {
      for (const promoAdvice of result) {
        if (!promoMap[promoAdvice.itemId]) {
          promoMap[promoAdvice.itemId] = {promoAdvice: [], loading: true};
        }
        const specificPromoRecord = promoMap[promoAdvice.itemId];
        specificPromoRecord.promoAdvice.push(promoAdvice);
      }
    }
  } catch (e) {
    Object.keys(promoMap).forEach((itemId) => {
      promoMap[itemId].loading = false;
    });
    return promoMap;
  }

  Object.keys(promoMap).forEach((itemId) => {
    promoMap[itemId].loading = false;
  });
  return promoMap;
};
